// @flow

import React, { Component } from 'react';
import InputRange from 'react-input-range';
import cx from 'classnames';
// import 'react-input-range/lib/css/index.css';
import './Range.scss';

type Props = {
  min: ?number,
  max: number,
  step: ?number,
  value: number,
  onChange: Function,
}

class Range extends Component<Props> {
  static defaultProps = {
    step: 1,
    min: 0,
    max: 100,
  };

  render() {
    const { min, max, step, value, onChange, disabled } = this.props;

    return (
      <div className={cx('uw-input-range-wrapper')} >
        <div className="range-value">
          {value}
        </div>
        <InputRange
          maxValue={max}
          minValue={min}
          value={value}
          onChange={onChange}
          step={step}
          disabled={disabled}
        />
      </div>
    );
  }
}

export default Range;
